export enum UserPurchaseActionTypes {
    API_RESPONSE_SUCCESS = '@@userPurchase/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@userPurchase/API_RESPONSE_ERROR',

    USER_CREATE = '@@userPurchase/USER_CREATE',

    RESET = '@@userPurchase/RESET',
}
